import { PaginationIndicatorColor } from "./types";

export const colorScheme: Record<
  PaginationIndicatorColor,
  { activeItemClassName: string; inactiveItemClassName: string }
> = {
  [PaginationIndicatorColor.Light]: {
    activeItemClassName: "bg-light",
    inactiveItemClassName: "bg-light bg-opacity-50",
  },
  [PaginationIndicatorColor.Neutral]: {
    activeItemClassName: "bg-neutral",
    inactiveItemClassName: "bg-neutral bg-opacity-50",
  },
  [PaginationIndicatorColor.Dark]: {
    activeItemClassName: "bg-dark",
    inactiveItemClassName: "bg-dark bg-opacity-50",
  },
  [PaginationIndicatorColor.Primary]: {
    activeItemClassName: "bg-primary",
    inactiveItemClassName: "bg-dark bg-opacity-50",
  },
  [PaginationIndicatorColor.PrimaryInverted]: {
    activeItemClassName: "bg-light border border-light",
    inactiveItemClassName: "bg-primary border border-light",
  },
};
